import Vue from 'vue';
//import axios from 'axios';

export default {
    state: {
        revenueAccounts: [],
    },

    getters: {
        
    },

    mutations: {
        setRevenueAccounts(state, revenueAccounts) {
            state.revenueAccounts = revenueAccounts;
        }
    },

    actions: {
        // Uhh, we're not really sharing these revenue accounts between components... we also probably shouldn't, since
        // we'd have to deal with contingencies of newly added revenue accounts, etc. I guess I just wanted to share the
        // method for fetching them, but to add it to a mixin (with a revenueAccounts property) would've been more suitable
        // TODO: Move to mixin
        fetchRevenueAccounts({ commit }, extraData) {
            let params = {
                type: 'revenue',
                designated_purpose: 'none',
                has_vat_types: 1
            };

            params = {...params, ...extraData };

            return  axios.get('accounts', { params }).then(response => {
                commit('setRevenueAccounts', response.data.accounts);
            }).catch(e => {
                commit('warningNotify', 'A product requires a revenue account, but no revenue accounts were found.');
            });
        },
    },
}